import { errorNotifier } from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const forgotPass = async (payload, setSignUp, setLoading) => {
  try {
    await http.post(AUTH_ROUTES.FORGOT_PASSWORD, payload);
    setSignUp("authlogin");
  } catch (e) {
    errorNotifier(
      e.response?.data?.data ||
      e.response?.data?.errors?.[0]?.msg ||
      e.message ||
      "Something went wrong",
    );
  } finally {
    setLoading(false);
  }
};

export const verifyCode = async (payload, setSignUp, setLoading, setResetToken) => {
  try {
    const result = await http.post(AUTH_ROUTES.VERIFY_CODE, payload);
    const token = result?.data?.data?.resetToken;
    if (token && setResetToken) {
      setResetToken(token);
    }
    setSignUp("newpassword");
  } catch (e) {
    errorNotifier(
      e.response?.data?.data ||
      e.response?.data?.errors?.[0]?.msg ||
      e.message ||
      "Something went wrong",
    );
  } finally {
    setLoading(false);
  }
};

export const newPass = async (payload, setSignUp, setLoading) => {
  try {
    await http.post(AUTH_ROUTES.FORGOT_PASSWORD_NEW, payload);
    setSignUp("signin");
  } catch (e) {
    errorNotifier(
      e.response?.data?.data ||
      e.response?.data?.errors?.[0]?.msg ||
      e.message ||
      "Something went wrong",
    );
  } finally {
    setLoading(false);
  }
};
